import { getLabel } from "../../common/getLabel"
import { baseUrl } from "../../common/config";
import Pagination from "../../common/reactPaginate";
import TableSkeleton from "../../common/TableSkeleton";
const Listing = (props) => {
    const { banners, totalCount, loading, error, handleFormShow, handlePaginate, calculateSerialNumber, limit, handleStatus, editBanner, deleteModalOpen, currentPage } = props;
    const handlePageClick = (selectedPage) => {
        handlePaginate(selectedPage);
    };
    const totalPages = Math.ceil(totalCount / limit);
    return (
        <>
            <form id="banner-listing">
                <table className="table table-striped table-bordered" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th className="table-id">{getLabel("LBL_Sr._No.")}</th>
                            <th>{getLabel("LBL_Title")}</th>
                            <th>{getLabel("LBL_Image")}</th>
                            <th>{getLabel("LBL_Status")}</th>
                            <th className="table-action">{getLabel("LBL_Action")}</th>
                        </tr>
                    </thead>
                    <tbody>

                        {loading ? (
                            <>
                                <TableSkeleton cards={limit} count={4} checkbox={true} />
                            </>
                        ) : error ? (
                            <tr className="no--record">
                                <td colspan="5" className="text-center">{getLabel("LBL_Some_thing_wrong_Please_try_again_later")}</td>
                            </tr>
                        ) : (
                            <>
                                {banners && banners.length > 0 ? (
                                    banners.map((elem, index) => {
                                        const imagePath = (elem.images) ? elem.images[0] : '';
                                        return (
                                            <tr className="actions" key={index} >
                                                <td>{calculateSerialNumber(index)}</td>
                                                <td>
                                                    <div className="verified-wrap">
                                                        <span className="user-profile_title">{elem.banner_heading} </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="userimg">
                                                        {imagePath &&
                                                            <img
                                                                src={`${baseUrl}/${imagePath.afile_physical_path}`}
                                                                className="img-fluid" />
                                                        }
                                                    </span>
                                                </td>
                                                <td>
                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            defaultChecked={elem.banner_status ? 1 : 0}
                                                            onChange={(e) =>
                                                                handleStatus(e, elem.banner_id, elem.banner_status)
                                                            }
                                                            disabled={!editBanner}
                                                        />

                                                        <span className="slider round"></span>
                                                    </label>
                                                </td>

                                                <td>
                                                    <span className="action">
                                                        <ul>
                                                            <li><a onClick={(() => handleFormShow(elem.banner_id))}><i className='bx bx-pencil'></i></a></li>
                                                            {editBanner && (
                                                                <li><a><i className="bx bx-trash" onClick={() => deleteModalOpen(elem.banner_id)} ></i></a></li>
                                                            )}
                                                        </ul>
                                                    </span>

                                                </td>
                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr className="no--record">
                                        <td colspan="5" className="text-center">{getLabel("LBL_No_result_found")}</td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </form>

            {banners && banners.length > 0 && (
                <Pagination
                    totalPages={totalPages}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage} />
            )}
        </>
    )
}

export default Listing